module.exports = __webpack_public_path__ + "img/loginlogo.e84b2e5e.png";